import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Flex, xcss } from '@atlaskit/primitives';
import Lozenge from '@atlaskit/lozenge';

const titleSpacingStyles = xcss({
	marginRight: 'space.075',
});

const lozengeContainerStyles = xcss({
	minWidth: '29.45px', //define minWidth so menu item lozenges (Labs, New, Join) can have consistent length
	display: 'flex',
	justifyContent: 'center',
});

export const ItemTitleWithLozenge = ({ children, lozenge }) => (
	<Flex alignItems="center" justifyContent="space-between">
		<Box xcss={titleSpacingStyles}>{children}</Box>
		<Lozenge appearance="new">
			<Box xcss={lozengeContainerStyles}>{lozenge}</Box>
		</Lozenge>
	</Flex>
);
